import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { useContext, useEffect, useState } from "react";
import { AppContext } from '../AppProvider';
import { BackgroundBeams } from "../Components/ui/background-beams";
import UITeam from "../Components/ui/UiTeam";
import CBSGCharLoader from '../Page/CBSGCharLoader';

const Team = () => {
  const [activeTeam, setActiveTeam] = useState("Core Team");
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { uri } = useContext(AppContext);

  const teamCategories = [
    { name: "Core Team", label: "Core Team", bgColor: "bg-base_300", textColor: "text-white" },
    { name: "Technical Expert", label: "Technical Team", bgColor: "bg-teal-700", textColor: "text-white" },
    { name: "International Consultant", label: "International Consultant", bgColor: "bg-black", textColor: "text-white" },
  ];

  useEffect(() => {
    axios.get(`${uri}team-members/`)
      .then((res) => {
        setEmployees(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching team members:", err);
        setError(err);
        setLoading(false);
      });

    AOS.init({
      duration: 1000,
      offset: 10,
      
    });
  }, [uri]);

  if (loading) {
    return <CBSGCharLoader />;
  }

  if (error) {
    return <p className="text-red-500">Error: {error.message}</p>;
  }

  const filteredEmployees = (category) => employees
    ?.filter(member => member?.category === category)
    .sort((a, b) => a.priority - b.priority) || [];

  return (
    <div className="relative mt-5 mb-5">
      {/* Desktop Section */}
      <section className="absolute left-24 justify-start items-center pl-5 mt-10 my-10 hidden md:flex">
        {teamCategories.map((team) => (
          <button
            key={team.name}
            data-aos="ease-in-out"
            onClick={() => setActiveTeam(team.name)}
            className={`p-3 rounded-tl-md font-semibold mx-1 ${activeTeam === team.name
              ? `text-white bg-gradient-to-tr from-base_900 to-base_500 shadow-md shadow-base_300 border-t-8 border-gray-300 rounded-t-lg`
              : "bg-gradient-to-tr from-base_900 to-base_500 bg-clip-text text-transparent border border-base_600 rounded-md"
            }`}
          >
            {team.label}
          </button>
        ))}
      </section>

      <div className={`hidden md:flex justify-center items-center mx-5 rounded pt-10 `}>
        {teamCategories.map((team) => (
          <div
            key={team.name}
            className={`max-w-[90%] mt-16 flex flex-col justify-center items-center ${activeTeam !== team.name ? 'hidden' : ''}`}
          >
            <UITeam cards={filteredEmployees(team.name)} />
          </div>
        ))}
      </div>

      {/* Mobile Section */}
      <div className="mt-8 block md:hidden">
        {teamCategories.map((team) => (
          <div key={team.name} className={`bg-gray-100 shadow-md flex flex-col justify-center items-center h-full w-full mb-8`}>
            <p
              className={`text-white mt-10 px-10 py-1 pl-5 rounded text-xl max-w-5xl w-full border shadow-md transition ease-in-out delay-150 text-left ${team.bgColor === 'bg-black' ? 'bg-gradient-to-r from-Golden_800 to-Golden_900' : (team.bgColor === 'bg-teal-700' ? 'bg-teal-700' : 'bg-gradient-to-r from-Coral_800 to-Coral_900')}`}
            >
              {team.label}
            </p>
            {team.name === "Core Team" && <BackgroundBeams />}
            <div className="z-[30] border-2">
              <UITeam cards={filteredEmployees(team.name)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;